"use client";

import {
  Banknote,
  Building2,
  CalendarCheck,
  DoorOpen,
  LayoutDashboard,
  Settings,
  TrendingUp,
} from "lucide-react";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";

// Demo navigation items with /demo prefix
const navItems = [
  {
    title: "Dashboard",
    url: "/demo/owner/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "Rentals",
    url: "/demo/owner/bookings",
    icon: CalendarCheck,
  },
  {
    title: "Analytics",
    url: "/demo/owner/analytics",
    icon: TrendingUp,
  },
  {
    title: "Payouts",
    url: "/demo/owner/payouts",
    icon: Banknote,
  },
  {
    title: "Rooms",
    url: "/demo/owner/rooms",
    icon: DoorOpen,
  },
  {
    title: "Settings",
    url: "/demo/owner/settings",
    icon: Settings,
  },
];

// Demo studio data
const demoStudio = {
  name: "Demo Studio",
  email: "demo@harmonydance.com",
};

export function DemoAppSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const location = useLocation();

  const isActive = (url: string) =>
    location.pathname === url || location.pathname.startsWith(url + "/");

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <div className="flex items-center gap-3 px-2 py-2">
              <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white flex h-8 w-8 items-center justify-center rounded-lg">
                <Building2 className="h-4 w-4" />
              </div>
              <div className="flex flex-col gap-0.5 leading-none">
                <span className="font-semibold font-benzin">Dnceclub</span>
                <span className="text-xs">{demoStudio.name}</span>
              </div>
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarMenu>
            {navItems.map((item) => (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(item.url)}
                  className="h-11 font-benzin"
                >
                  <Link to={item.url}>
                    {item.icon && <item.icon className="h-5 w-5" />}
                    <span className="text-sm font-medium">{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
